import { App } from 'vue';
import * as Sentry from '@sentry/vue';
import config from '@/config';
import pkg from '../package.json';
import { Router } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

export default class SentryApi {
  private static _inited = false;
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  static init(app: App, router: Router) {
    if (SentryApi._inited) {
      // eslint-disable-next-line no-console
      console.log('Sentry already inited');
      return;
    }
    try {
      Sentry.init({
        app: app,
        dsn: config.sentry.dsn,
        debug: config.sentry.debug,
        enabled: config.sentry.enabled,
        environment: config.sentry.environment,
        replaysSessionSampleRate: config.sentry.replaySessions,
        replaysOnErrorSampleRate: config.sentry.errorReplaySessions,
        release: `${config.sentry.project}@${pkg.version}`,
        integrations: [
          Sentry.browserTracingIntegration({ router }),
          Sentry.replayIntegration(),
        ],
        attachStacktrace: true,
        autoSessionTracking: true,
        maxBreadcrumbs: config.sentry.maxBreadcrumbs,
        tracesSampleRate: config.sentry.tracesSampleRate,
        beforeSend(event) {
          if (SentryApi.isDevMode()) {
            return null;
          }
          const { username, accountId, role, userId } = useAuthStore();
          event.tags = {
            userId: userId,
            accountId: accountId,
            feature: config.FEATURE,
            username: username,
            role: role,
          };

          return event;
        },
      });
      SentryApi._inited = true;
    }
    catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
    }
  }
  static captureException(err: unknown) {
    if (!SentryApi.isDevMode()) {
      Sentry.captureException(err);
    }
    console.error(err);
  }

  private static isDevMode() {
    return process.env.NODE_ENV === 'development';
  }
}
